
class ProductStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    // Options
    this.options = {
      behaviour: "smart",
    }

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions
      };
    }

    this.mainButtons = document.getElementById('productFormButtons');

    // Check if bar need to show on init
    if (this.options.behaviour === 'always' && window.innerWidth < 768) {
      this.showBar();
    }

    this.debouncedOnLoad = debounce((event) => {
      // when bottom is reached, hide the bar. Use math because it can return a half pixel...
      if (event.type === 'scroll' && (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight) {
        this.hideBar();
        return
      }
      if (this.options.behaviour === 'smart' || (this.options.behaviour === 'always' && window.innerWidth >= 768)) {
        this.observeBar(event);
      } else {
        this.showBar();
      }
    }, 50);

    window.addEventListener('scroll', this.debouncedOnLoad.bind(this));
  }

  observeBar(event) {
    // register IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const elementBounds = entry.boundingClientRect;
        const isBottomVisible = (elementBounds.top <= 10 );
        // display the bar when the ATC button is out of screen
        if (isBottomVisible) {
          this.showBar();
        }
        else {
          this.hideBar();
        }
      });
    });
    // declares what to observe, and observes its properties.
    observer.observe(this.mainButtons);
  }

  showBar() {
    if (!this.classList.contains('product-sticky--active')) {
      this.classList.add('product-sticky--active');
    }
  }

  hideBar() {
    if (this.classList.contains('product-sticky--active')) {
      this.classList.remove('product-sticky--active');
    }
  }
}

if(!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', ProductStickyAddToCart);
}
